import Vue from 'vue';
import SharedPlugin from './plugins/SharedPlugin';
import ProductPlugin from './plugins/ProductPlugin';
import store from './store';
import { vueInstanceApiFactory } from './core/apiFactory';
import { generateApis } from './core/api';
import VueSocialSharing from 'vue-social-sharing';
import VCalendar from 'v-calendar';
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^cts-/];
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});
Vue.use(SharedPlugin);
Vue.use(ProductPlugin);
Vue.use(VueSocialSharing);
// FILTERS
Vue.filter('stripHTML', (value) => {
    const div = document.createElement('div');
    div.innerHTML = value;
    return div.textContent || div.innerText || '';
});
Vue.filter('str_limit', (value, size) => {
    if (!value)
        return '';
    value = value.toString();
    if (value.length <= size) {
        return value;
    }
    return value.substr(0, size) + '...';
});
Vue.filter('formatPriceNoSymbol', (value) => {
    if (!value)
        return '';
    return (value / 1).toFixed(2);
});
// Vue 2 global filter — ONLY pass the amount
// Reads:
//   localStorage.preferredCurrency  -> e.g. "SGD", "USD", "GBP"
//   localStorage.preferredLocale    -> e.g. "en-SG", "en-SG" (optional)
Vue.filter('formatPrice', (value) => {
    if (value === null || value === undefined)
        return '—';
    const num = Number(value);
    if (Number.isNaN(num))
        return '—';
    const { currency, locale } = getUserCurrencyPrefs();
    // 1) Resolve a good locale (favor the currency’s home locale)
    const fallbackByCurrency = {
        SGD: 'en-SG', USD: 'en-US', GBP: 'en-GB', EUR: 'en-IE', AUD: 'en-AU',
        CAD: 'en-CA', NZD: 'en-NZ', HKD: 'en-HK', JPY: 'ja-JP', CNY: 'zh-CN', INR: 'en-IN',
    };
    const resolvedLocale = locale ||
        fallbackByCurrency[currency] ||
        (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
    // 2) Use the WIDE symbol explicitly (NOT narrowSymbol)
    const formatter = getCachedFormatter(resolvedLocale, currency, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
    });
    let out = formatter.format(num);
    // 3) Safety fix for some Safari/old runtimes that still give "$" for SGD
    //    If the currency is SGD and the formatted parts used the narrow symbol "$", replace with "S$".
    if (currency === 'SGD') {
        const parts = formatter.formatToParts(num);
        const curPart = parts.find(p => p.type === 'currency')?.value;
        if (curPart === '$') {
            out = parts.map(p => (p.type === 'currency' ? 'S$' : p.value)).join('');
        }
    }
    return out;
});
// ---- helpers ----
function getUserCurrencyPrefs() {
    let currency = 'SGD';
    let locale = null;
    if (typeof window !== 'undefined' && window.localStorage) {
        const storedCurrency = localStorage.getItem('preferredCurrency');
        const storedLocale = localStorage.getItem('preferredLocale');
        if (storedCurrency)
            currency = storedCurrency.toUpperCase();
        locale = storedLocale;
    }
    if (!/^[A-Z]{3}$/.test(currency))
        currency = 'SGD';
    return { currency, locale };
}
const _fmtCache = new Map();
function getCachedFormatter(locale, currency, opts) {
    const key = `${locale}:${currency}:${JSON.stringify(opts)}`;
    let fmt = _fmtCache.get(key);
    if (!fmt) {
        fmt = new Intl.NumberFormat(locale, opts);
        _fmtCache.set(key, fmt);
    }
    return fmt;
}
generateApis(vueInstanceApiFactory);
const isLoginHost = typeof window !== "undefined" &&
    window.location.hostname === process.env.VUE_APP_LOGIN_HOST;
const routerToUse = isLoginHost
    ? require("./router/index.ts").default
    : require("./router/index.ts").default;
const appToUse = isLoginHost
    ? require("./App.vue").default
    : require("./App.vue").default;
// Must be above `new Vue(...)`
(function redirectOffLoginHost() {
    if (typeof window === "undefined")
        return;
    const loginHost = process.env.VUE_APP_LOGIN_HOST || "login.cr.local";
    // Only allow these on the login subdomain
    const path = window.location.pathname;
    const allowed = path === "/callback" ||
        path === "/ciam/login" ||
        path === "/ciam/callback" ||
        path === "/ciam/logout";
    if (window.location.hostname === loginHost && !allowed) {
        const mainOrigin = process.env.VUE_APP_DEFAULT_MAIN_ORIGIN ||
            "https://attractions.cr.local:8081";
        const target = mainOrigin +
            window.location.pathname +
            window.location.search +
            window.location.hash;
        window.location.replace(target);
    }
})();
new Vue({
    router: routerToUse,
    store,
    data: () => ({
        simple_layout: localStorage.getItem('simple_layout') === '1'
    }),
    render: (h) => h(appToUse),
}).$mount("#app");
